import { Box } from "@mui/material";
import React from "react";
import SideNav from "../../../agentComponents/sidenav";
import CampaignMonitor from "./CampaignMonitor";

const CampaignMonitorView = () => {
    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    p: {
                        xs: "50px 0 0 0",
                        md: "50px 20px",
                    },
                    bgcolor: "white",
                }}
            >
                <SideNav />
                <Box sx={{ width: "100%" }}>
                    <CampaignMonitor />
                </Box>
            </Box>
        </div>
    );
};

export default CampaignMonitorView;
